/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect, useRef } from "react";
import * as API from '../../http/api';
import { openlightbox } from "../../util/Functions";
import ContraCargoNoReconocidoCacao from "../modals/cartas/ContraCargoNoReconocidoCacao";
import ContraCargoInternacional from "./../../components/modals/cartas/ContraCargoInternacional";
import ContraCargoNacionales from "./../../components/modals/cartas/ContraCargoNacionales";
import ContraCargoDispta from "./../../components/modals/cartas/ContraCargoDisputa";
import CargoDisputaCacao from "./../../components/modals/cartas/CargoDisputaCacao";
import ContraCargoSpei from "../modals/cartas/ContraCargoSpei";
import R27 from "./../../components/modals/R27";
import PldModalController from "../modals/PldModalController";
import DataTable from "react-data-table-component";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles4 } from "../../util/TableStyles"
import { Stack, Button, IconButton, Tooltip, Dialog, DialogTitle, Typography, DialogContent, DialogActions, FormControl, InputLabel, Select, MenuItem, AppBar, Toolbar, Grid, TextField, Input } from '@mui/material';
import InfoTx from "./InfoTx";
import moment from "moment";
import "moment/locale/es";
import { Close, DynamicForm, Info, ArrowCircleDown, Public, ErrorOutline, SummarizeOutlined, AttachEmail, Filter8Outlined, ReceiptLong, AttachEmailOutlined } from "@mui/icons-material";

import { noDataComponent } from "../../util/DataObject"
import { CommonService } from '../../services/CommonService';
import CustomMenu from "./CustomMenu";

const DataTx = (props) => {
	moment.locale("es");
	const [headers, setHeaders] = useState([]);
	const [data, setData] = useState([]);
	const [openModal, setOpenModal] = useState(false);
	const [disabled, setDisabled] = useState(true);
	const [report, setReport] = useState('');
	const [reports, setReports] = useState([]);
	const [fields, setFields] = useState([]);
	const [tx, setTx] = useState({});
	const [openForm, setOpenForm] = useState(false);
	const [titleForm, setTitleForm] = useState('');
	const commonService = useRef<CommonService>();

	const [menuOptions, setMenuOptions] = useState([
		{ key: "letterTutukaContra", label: "Carta Internacional", icon: <Public/>, show: false, channel: "tutuka" },
        { key: "letterTutukaDisputa", label: "Fraude", icon: <ErrorOutline/>, show: false, channel: "tutuka" },
        { key: "letterTutukaCargo", label: "Anexo 8", icon: <Filter8Outlined/>, show: false, channel: "tutuka" },
        { key: "letterSpei", label: "Carta Spei", icon: <ReceiptLong/>, show: false, channel: "tutuka" },
        { key: "letterCacaoContra", label: "Contracargos Cacao", icon: <AttachEmailOutlined/>, show: false, channel: "cacao" },
        { key: "letterCacaoDisputa", label: "Disputa Cacao", icon: <AttachEmail/>, show: false, channel: "cacao" },
		{ key: "r27", label: "R27", icon: <SummarizeOutlined/>, show: false },
        { key: "downloadPDF", label: "Descargar comprobante", icon: <ArrowCircleDown/>, show: false },
        { key: "pld", label: "Reporte regulatorio PLD", icon: <DynamicForm/>, show: false },
        { key: "tracking", label: "Detalle", icon: <Info/>, show: false },
    ]);

	const actionExecute = (item, key) => {
        switch (key) {
            case "letterTutukaContra":
            case "letterTutukaDisputa":
            case "letterTutukaCargo":
            case "letterSpei":
                return getCartasContraCargos(key, item);
			case "letterCacaoContra":
			case "letterCacaoDisputa":
                return getCartasContraCargos(key, item);
			case "downloadPDF":
                return props.download(item);
            case "r27":
                return getR27(item);
			case "pld":
                return openModalPld(item);
			case "tracking":
                return props.spaceTxTracking(item);
            default:
                break;
        }
        return 
    };

	useEffect(() => {
		commonService.current = new CommonService(props.changeAlert)
		setHeaders(JSON.parse(JSON.stringify(props.headers)));
		setData(JSON.parse(JSON.stringify(props.data)));

		let m = menuOptions;

		m.map((item) => {
			props.config["actions"].indexOf(item.key) > -1 ? item.show = true : item.show = false
		});

		setMenuOptions(m);
	}, [props.data]);

	const switchCase = [
		{ key: "letterTutukaContra", modal: ContraCargoInternacional },
		{ key: "letterTutukaDisputa", modal: ContraCargoDispta },
		{ key: "letterTutukaCargo", modal: ContraCargoNacionales },
		{ key: "letterCacaoContra", modal: ContraCargoNoReconocidoCacao },
		{ key: "letterCacaoDisputa", modal: CargoDisputaCacao },
		{ key: "letterSpei", modal: ContraCargoSpei }
	];
	const getCartasContraCargos = (value, data) => {
		switchCase.map((i) => {
			if(i.key === value){
				const as = (
					React.createElement(
						i.modal,
						{
							data: data,
							pos: props.pos,
							spacesList: props.spacesList,
							spaceUuid: props.spaceUuid,
							changeAlert: props.changeAlert,
							changeLoader: props.changeLoader,
							customer: props.customer,
							config: props.config,
						}
					)
				)
				openlightbox(as);            
			}
		})
	};

	const getR27 = async (req) => {
        props.changeLoader(true);
		var dataRequest = {
			"operation":"getByTrxId",
			"data": {
				"uuid" : req.uuid,    
			}
		}
		let request = await API.service('r27', dataRequest, props.pos, props.changeAlert, props.changeLoader, props.history);
		
		if (request.status == 200) {
			if (request.data.data.response == 'OK') {
				let getCatalogs = await catalogGet()

				if(request.data.data.widget[0].content.data.content[0]){
					let dataSend = request.data.data.widget[0].content.data.content[0];
					dataSend.hasUpdate = true;
					const as = (
						<R27
							data={dataSend}
							pos={props.pos}
							spacesList={props.spacesList}
							spaceUuid={props.spaceUuid}
							changeAlert={props.changeAlert}
							changeLoader={props.changeLoader}
							customer={props.customer}
							hasFilter={false}
							listTx={data}
							dates={props.newDates}
							reload={props.reloadPage}
							catalogs={getCatalogs}
							pagination={{
								rowsPerPage: Number(props.pagination.rowsPerPage),
								totalRows: Number(props.pagination.totalRows),
								page: Number(props.pagination.page)
							}}
						/>
					);
					openlightbox(as);
				}else{
					req.hasUpdate = false;
					const as = (
						<R27
							data={req}
							pos={props.pos}
							spacesList={props.spacesList}
							spaceUuid={props.spaceUuid}
							changeAlert={props.changeAlert}
							changeLoader={props.changeLoader}
							customer={props.customer}
							hasFilter={false}
							listTx={data}
							dates={props.dates}
							reload={props.reloadPage}
							catalogs={getCatalogs}
							pagination={{
								rowsPerPage: Number(props.pagination.rowsPerPage),
								totalRows: Number(props.pagination.totalRows),
								page: Number(props.pagination.page)
							}}
						/>
					);
					openlightbox(as);
				} 
			}
		}
        props.changeLoader(false);
	}

	const catalogGet = async () => {
		let payload = {
			catalog: {
				id: "chargebacks_reason"
			}
		};
  
		const response = await commonService.current.getCatalog(payload);
		if(response?.data?.response === 'OK'){
			let catalogResp = response.data.catalog;
			let resolve_catalog = catalogResp.filter((c) => c.m[0]['action_type'] === "resolve");
			resolve_catalog.sort(comparar);
  
			let reason_catalog = catalogResp.filter((c) => c.m[0]['action_type'] === "complaint");
			reason_catalog.sort(comparar);
  
			return [resolve_catalog, reason_catalog]
		} else {
			props.changeAlert(true, 'error', response.data.message);
		}
	}
  
	function comparar(a: Object, b: Object) {
		return a['k'].localeCompare(b['k']);
	}

	//   ------------------------------------------------------------------
	const columns = [];

	const init = async () => {
		headers?.map((itemH, indexH) => {
			if (itemH && itemH.hasOwnProperty("moment")) {
				columns.push({
					selector: (row) => moment(new Date(row[itemH.key])).tz('America/Mexico_City').format(itemH.moment),
					name: itemH.name, sortable: true, width: "15%",
				});
			} else if (itemH && !itemH.hasOwnProperty("options") && itemH.key !== "amountFormated") {
				columns.push({
					selector: (row) => row[itemH.key] || "---" ,
					name: itemH.name, sortable: true, wrap: true,
					width:
						itemH.key === "description" ? "35%" : "10%"
				});
			} else if (itemH && !itemH.hasOwnProperty("options") && itemH.key === "amountFormated" && props.validateVip) {
				columns.push({
					selector: (row) => row[itemH.key], name: itemH.name, sortable: true, wrap: true, width: "12%", right: true 
				});
			}
		});

		columns.push({ cell: (item) => {
				let m = menuOptions;
				let r27 = false;
				if(["approved", "on_transit", "confirmed", "settled", "accepted", 'reversed' ].indexOf(item.status) >-1){
					if(!item.chargeback || (item.chargeback && item.chargeback.status !== "done")){
						r27 = true;
						m.map((i) => {
							if (i.key === "r27" && i.show) {
								i.show = r27;
							}
							if (item.channelDesc === "Tutuka" && i.key.includes("Cacao")){
								i.show = false
							}
							if (item.channelDesc === "Cacao" && (i.key.includes("Tutuka") || i.key === "letterSpei")){
								i.show = false
							}
						})
					}
				}

				let filterList = m.filter((i) => i.show === true)
				return (<CustomMenu size="small" row={item} options={filterList} action={actionExecute} />)
			},
			allowOverflow: true, button: true, width: "2%"
		})
	};

	if (headers) {
		init();
	}

	const viewInfo = (item, index) => {
		return <div className="select_info">
			<InfoTx
				countries={props.countries}
				banks={props.banks}
				data={item.data}
				validateVip={props.validateVip}
				config={props.config}
			/>
		</div>
	};

	const openModalPld = async (item) => {

    const as = (
		<PldModalController
			data={item}
			customer={props.customer}
			pos={props.pos}
			spacesList={props.spacesList}
			spaceUuid={props.spaceUuid}
			changeAlert={props.changeAlert}
			changeLoader={props.changeLoader}
			catalogs = {props.catalogs}
		/>
    );
    openlightbox(as);
    /*

		setTx(JSON.parse(JSON.stringify(item)));
		props.changeLoader(true);
		let request = await API.service('openModalPld', {}, props.pos, props.changeAlert, props.changeLoader, props.history);
		if (request.status == 200) {
			if (request.data.data.response == 'OK') {
				if(request.data.data.widget[0].type == 'modalPld'){
					if(request.data.data.widget[0].content.catalog){
						setOpenModal(true);
						setReports(JSON.parse(JSON.stringify(request.data.data.widget[0].content.catalog)));
					}
				}
			}
		}
		props.changeLoader(false);
    */
	}

	const openModalPldForm = async () => {
		setOpenModal(false);
		props.changeAlert(false, '', '');
		props.changeLoader(true);
		let data = {
			report: report
		}
		let request = await API.service('openModalPldForm', data, props.pos, props.changeAlert, props.changeLoader, props.history);
		if (request.status == 200) {
			if (request.data.data.response == 'OK') {
				setReport('');
				setDisabled(true);
				if(request.data.data.widget[0].type == 'modalPldForm'){
					if(request.data.data.widget[0].content.fields && request.data.data.widget[0].content.fields.length > 0){
						setOpenForm(true);
						setTitleForm(request.data.data.widget[0].content.label);
						let f = request.data.data.widget[0].content.fields;
						for(let i = 0; i<f.length; i++){
							if(f[i]['findValue']){
								let find = f[i]['findValue'].split('.');
								let value = tx;
								for(let j = 0; j<find.length; j++){
									if(value.hasOwnProperty(find[j])){
										value = value[find[j]];
									}
								}
	
								f[i]['value'] = typeof(value) != 'object' ? value : '';
							}

							if(f[i]['type'] == 'select' && f[i]['catalog']){
								f[i]['values'] = props.catalogs[f[i]['catalog']];
							}
						}
						setFields(JSON.parse(JSON.stringify(f)));
						//setOpenModal(true);
						//setReports(JSON.parse(JSON.stringify(request.data.data.widget[0].content.catalog)));
					}
				}
			}
		}else{
			setOpenModal(true);
		}
		props.changeLoader(false);
	}

	const changeModal = (flag) => {
		setOpenModal(flag);
		if(!flag){
			setTx({});
			setDisabled(true);
		}
	}

	const changeReport = (e) => {
		setReport(e.target.value);
		if(e.target.value){
			setDisabled(false);
		}else{
			setDisabled(true);
		}
	}

	const changeFlagForm = (flag) => {
		setOpenForm(flag);
		if(!flag){
			setTx({});
			setFields([]);
			setDisabled(true);
		}
	}

	const changeValue = (index, e) => {
		let f = fields;
		f[index]['value'] = f[index]['type'] == 'number' ? Number(e.target.value) : e.target.value;
		setFields(JSON.parse(JSON.stringify(f)));
		validateForm(f);
	}

	const validateForm = (f) => {
		let requires = 0;
		let values = 0;
		for(let i = 0; i<f.length; i++){
			if(f[i]['required']){
				requires++;
			}
			if(f[i]['value'].toString().length > 0){
				values++;
			}
		}	
		if(values >= requires){
			setDisabled(false);
		}else{
			setDisabled(true);
		}
	}

  const buildData = (fields)=>{
    let data:any ={}
    fields.forEach(element => {
      data[element.findValue] = element.value;
    });
    return data;
  }

  const aceptar = async ()=>{ 

    switch(titleForm){

      case 'Internas Preocupantes':{
        let dataRequest = buildData(fields);
        let data  = {
          "data": {
              "tipo_reporte": "interna_preocupante",
              "empleado": {
                  "pais_nacionalidad": dataRequest.pais_nacionalidad,
                  "nombre": dataRequest.nombre,
                  "apellido_paterno": dataRequest.apellido_paterno,
                  "apellido_materno": dataRequest.apellido_materno,
                  "genero": dataRequest.genero,
                  "rfc":dataRequest.rfc,
                  "curp": dataRequest.curp,
                  "fecha_nacimiento": dataRequest.fecha_nacimiento,
                  "entidad_nacimiento": dataRequest.entidad_nacimiento,
                  "telefono": dataRequest.telefono,
                  "puesto_entidad": dataRequest.puesto_entidad,
                  "address": {
                      "entidad_federativa_domicilio": dataRequest.entidad_federativa_domicilio,
                      "calle_domicilio": dataRequest.calle_domicilio,
                      "colonia": dataRequest.colonia,
                      "ciudad_poblacion": dataRequest.ciudad_poblacion,
                      "codigo_postal": dataRequest.codigo_postal
                  },
                  "operacion": {
                      "tipo_operacion_itf": dataRequest.tipo_operacion_itf,
                      "monto":dataRequest.monto,
                      "instrumento_monetario": dataRequest.instrumento_monetario,
                      "moneda": dataRequest.moneda,
                      "fecha": dataRequest.fecha
                  },
                  "analisis": {
                      "fecha_deteccion": dataRequest.fecha_deteccion,
                      "descripcion_perﬁl_empleado": dataRequest.descripcion_perﬁl_empleado,
                      "razones_vulnera_pld": dataRequest.razones_vulnera_pld,
                      "prioridad_reporte": dataRequest.prioridad_reporte
                  },
                  "cliente":{
                      "tipo_persona_cliente":dataRequest.tipo_persona_cliente,
                      "razon_denominacion_cliente":dataRequest.razon_denominacion_cliente,
                      "nombre_cliente":dataRequest.nombre_cliente,
                      "apellido_paterno_cliente":dataRequest.apellido_paterno_cliente,
                      "apellido_materno_cliente":dataRequest.apellido_materno_cliente,
                      "rfc_cliente":dataRequest.rfc_cliente,
                      "curp_cliente":dataRequest.curp_cliente,
                      "fecha_nacimiento_cliente":dataRequest.fecha_nacimiento_cliente,
                      "numero_cuenta_cliente":dataRequest.numero_cuenta_cliente
                  }
              }
          }
        }

        break;
      }
      case 'Inusual':{
        let dataRequest = buildData(fields);
        let data = {
          "data": {
              "tipo_reporte": "inusual",
              "space_account": {
                  "uuid":"UUID del space_account"
              },
              "customer": {
                  "uuid":"UUID del customer"
              },
              "operacion": { 
                  "uuid":"UUID de la Tx",
                  "instrumento_monetario": dataRequest.instrumento_monetario,
                  "fecha_deteccion":dataRequest.fecha_deteccion,
              },
              "analisis": {
                  "descripcion_operacion": dataRequest.descripcion_operacion,
                  "razon_inusual": dataRequest.razon_inusual,
                  "fecha_inicio_perﬁl": dataRequest.fecha_inicio_perﬁl,
                  "fecha_ﬁn_perﬁl": dataRequest.fecha_ﬁn_perﬁl,
                  "tipo_operacion_perﬁl": dataRequest.tipo_operacion_perﬁl,
                  "prioridad_reporte": dataRequest.prioridad_reporte,
                  "alerta":dataRequest.alerta
              },
              "contraparte": {
                  "tipo_persona_contraparte": dataRequest.tipo_persona_contraparte,
                  "razon_denominacion_contraparte": dataRequest.razon_denominacion_contraparte,
                  "nombre_contraparte": dataRequest.nombre_contraparte,
                  "apellido_paterno_contraparte": dataRequest.apellido_paterno_contraparte,
                  "apellido_materno_contraparte": dataRequest.apellido_materno_contraparte,
                  "nacionalidad_cuenta_contraparte": dataRequest.nacionalidad_cuenta_contraparte,
                  "institucion_ﬁnanciera_contraparte": dataRequest.institucion_ﬁnanciera_contraparte,
                  "cuenta_clabe_contraparte": dataRequest.cuenta_clabe_contraparte
              }
          }
        }

        //let request = await API.service('pld', data, props.pos, props.changeAlert, props.changeLoader, history);

        //console.log(request)

        break;
      }
    }
  }

	return <div style={{ width: "100%" }}>
		<ThemeProvider theme={theme}>
			<DataTable
				columns={columns}
				data={data}
				expandableRows={true}
				expandOnRowClicked={false}
				expandableRowsComponent={viewInfo}
				customStyles={customStyles4}
				noDataComponent={noDataComponent}
			/>
			<Dialog open={openModal} fullWidth>
				<DialogTitle>
					<Typography
						component={'div'}
						children={'Seleccione una opción'}
						fontWeight="bold"
						fontFamily="Muli,sans-serif"
						fontSize="20px"
						sx={{
							margin: '2.1% !important'
						}}
					/>
					
					<IconButton
						sx={{
							position: 'absolute',
							right: 8,
							top: 8
						}}
						onClick={changeModal.bind(this, false)}
					>
						<Close/>
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					<FormControl variant="standard" fullWidth>
						<InputLabel id="label-pld">Tipo de reporte</InputLabel>
						<Select labelId="label-pld" value={report} onChange={changeReport.bind(this)}>
							<MenuItem value=""></MenuItem>
							{
								reports.map((item, index) => {
									return <MenuItem value={item.uuid} key={`select-pld-${index}`}>{item.label}</MenuItem>
								})
							}
						</Select>
					</FormControl>
				</DialogContent>
				<DialogActions>
					<Button variant="contained" sx={{textTransform: 'none'}} disabled={disabled} onClick={openModalPldForm.bind(this)}>Aceptar</Button>
				</DialogActions>
			</Dialog>

			<Dialog open={openForm} fullScreen>
				<AppBar sx={{position: 'static'}}>
					<Toolbar>
						<Typography
							component={'div'}
							children={titleForm}
							fontWeight="bold"
							fontFamily="Muli,sans-serif"
							fontSize="20px"
							sx={{
								width: '100%'
							}}
						/>
						<IconButton
							edge="end"
							color="inherit"
							onClick={changeFlagForm.bind(this, false)}
						>
							<Close/>
						</IconButton>
					</Toolbar>
				</AppBar>
				<Grid container spacing={2} sx={{marginTop: '10px'}}>
					{
						fields.map((item, index) => {
              if(item.show){

                if(index % 4 == 0){
                  if(item.type == 'text' || item.type == 'number'){
                    return <Grid item xs={3} key={`field-${index}`}>
                      <FormControl variant="standard" required={item.required} fullWidth sx={{marginLeft: '2% !important'}}>
                        <InputLabel htmlFor={`field-${index}`}>{item.label}</InputLabel>
                        <Input
                          value={item.value}
                          type={item.type}
                          id={`field-${index}`}
                          onChange={changeValue.bind(this, index)}
                        />
                      </FormControl>
                    </Grid>
                  }
                  if(item.type == 'select' && !item.catalog){
                    return <Grid item xs={3} key={`field-${index}`}>
                      <FormControl variant="standard" required={item.required} fullWidth sx={{marginLeft: '2% !important'}}>
                        <InputLabel id="label-pld">{item.label}</InputLabel>
                        <Select labelId="label-pld" value={item.value} onChange={changeValue.bind(this, index)}>
                          <MenuItem value=""></MenuItem>
                          {
                            item.values.map((item2, index2) => {
                              return <MenuItem value={item2.key} key={`select-pld-${index2}`}>{item2.label}</MenuItem>
                            })
                          }
                        </Select>
                      </FormControl>
                    </Grid>
                  }
                  if(item.type == 'select' && item.catalog){
                    return <Grid item xs={3} key={`field-${index}`}>
                      <FormControl variant="standard" required={item.required} fullWidth sx={{marginLeft: '2% !important'}}>
                        <InputLabel id="label-pld">{item.label}</InputLabel>
                        <Select labelId="label-pld" value={item.value} onChange={changeValue.bind(this, index)}>
                          <MenuItem value=""></MenuItem>
                          {
                            item.values.map((item2, index2) => {
                              return <MenuItem value={item2.k} key={`select-pld-${index2}`}>{item2.v}</MenuItem>
                            })
                          }
                        </Select>
                      </FormControl>
                    </Grid>
                  }
                }
                if(index % 4 == 1){
                  if(item.type == 'text' || item.type == 'number'){
                    return <Grid item xs={3} key={`field-${index}`}>
                      <FormControl variant="standard" required={item.required} fullWidth>
                        <InputLabel htmlFor={`field-${index}`}>{item.label}</InputLabel>
                        <Input
                          value={item.value}
                          type={item.type}
                          id={`field-${index}`}
                          onChange={changeValue.bind(this, index)}
                        />
                      </FormControl>
                    </Grid>
                  }
                  if(item.type == 'select' && !item.catalog){
                    return <Grid item xs={3} key={`field-${index}`}>
                      <FormControl variant="standard" required={item.required} fullWidth>
                        <InputLabel id="label-pld">{item.label}</InputLabel>
                        <Select labelId="label-pld" value={item.value} onChange={changeValue.bind(this, index)}>
                          <MenuItem value=""></MenuItem>
                          {
                            item.values.map((item2, index2) => {
                              return <MenuItem value={item2.key} key={`select-pld-${index2}`}>{item2.label}</MenuItem>
                            })
                          }
                        </Select>
                      </FormControl>
                    </Grid>
                  }
                  if(item.type == 'select' && item.catalog){
                    return <Grid item xs={3} key={`field-${index}`}>
                      <FormControl variant="standard" required={item.required} fullWidth sx={{marginLeft: '2% !important'}}>
                        <InputLabel id="label-pld">{item.label}</InputLabel>
                        <Select labelId="label-pld" value={item.value} onChange={changeValue.bind(this, index)}>
                          <MenuItem value=""></MenuItem>
                          {
                            item.values.map((item2, index2) => {
                              return <MenuItem value={item2.k} key={`select-pld-${index2}`}>{item2.v}</MenuItem>
                            })
                          }
                        </Select>
                      </FormControl>
                    </Grid>
                  }
                }
                if(index % 4 == 2){
                  if(item.type == 'text' || item.type == 'number'){
                    return <Grid item xs={3} key={`field-${index}`}>
                      <FormControl variant="standard" required={item.required} fullWidth>
                        <InputLabel htmlFor={`field-${index}`}>{item.label}</InputLabel>
                        <Input
                          value={item.value}
                          type={item.type}
                          id={`field-${index}`}
                          onChange={changeValue.bind(this, index)}
                        />
                      </FormControl>
                    </Grid>
                  }
                  if(item.type == 'select' && !item.catalog){
                    return <Grid item xs={3} key={`field-${index}`}>
                      <FormControl variant="standard" required={item.required} fullWidth>
                        <InputLabel id="label-pld">{item.label}</InputLabel>
                        <Select labelId="label-pld" value={item.value} onChange={changeValue.bind(this, index)}>
                          <MenuItem value=""></MenuItem>
                          {
                            item.values.map((item2, index2) => {
                              return <MenuItem value={item2.key} key={`select-pld-${index2}`}>{item2.label}</MenuItem>
                            })
                          }
                        </Select>
                      </FormControl>
                    </Grid>
                  }
                  if(item.type == 'select' && item.catalog){
                    return <Grid item xs={3} key={`field-${index}`}>
                      <FormControl variant="standard" required={item.required} fullWidth sx={{marginLeft: '2% !important'}}>
                        <InputLabel id="label-pld">{item.label}</InputLabel>
                        <Select labelId="label-pld" value={item.value} onChange={changeValue.bind(this, index)}>
                          <MenuItem value=""></MenuItem>
                          {
                            item.values.map((item2, index2) => {
                              return <MenuItem value={item2.k} key={`select-pld-${index2}`}>{item2.v}</MenuItem>
                            })
                          }
                        </Select>
                      </FormControl>
                    </Grid>
                  }
                }
                if(index % 4 == 3){
                  if(item.type == 'text' || item.type == 'number'){
                    return <Grid item xs={3} key={`field-${index}`}>
                      <FormControl variant="standard" required={item.required} fullWidth>
                        <InputLabel htmlFor={`field-${index}`}>{item.label}</InputLabel>
                        <Input
                          value={item.value}
                          type={item.type}
                          id={`field-${index}`}
                          onChange={changeValue.bind(this, index)}
                        />
                      </FormControl>
                    </Grid>
                  }
                  if(item.type == 'select' && !item.catalog){
                    return <Grid item xs={3} key={`field-${index}`}>
                      <FormControl variant="standard" required={item.required} fullWidth>
                        <InputLabel id="label-pld">{item.label}</InputLabel>
                        <Select labelId="label-pld" value={item.value} onChange={changeValue.bind(this, index)}>
                          <MenuItem value=""></MenuItem>
                          {
                            item.values.map((item2, index2) => {
                              return <MenuItem value={item2.key} key={`select-pld-${index2}`}>{item2.label}</MenuItem>
                            })
                          }
                        </Select>
                      </FormControl>
                    </Grid>
                  }
                  if(item.type == 'select' && item.catalog){
                    return <Grid item xs={3} key={`field-${index}`}>
                      <FormControl variant="standard" required={item.required} fullWidth sx={{marginLeft: '2% !important'}}>
                        <InputLabel id="label-pld">{item.label}</InputLabel>
                        <Select labelId="label-pld" value={item.value} onChange={changeValue.bind(this, index)}>
                          <MenuItem value=""></MenuItem>
                          {
                            item.values.map((item2, index2) => {
                              return <MenuItem value={item2.k} key={`select-pld-${index2}`}>{item2.v}</MenuItem>
                            })
                          }
                        </Select>
                      </FormControl>
                    </Grid>
                  }
                }
              }
            })
					}
				</Grid>
				<DialogActions>
					<Button variant="contained" sx={{textTransform: 'none'}} onClick={aceptar} >Aceptar</Button>
				</DialogActions>
			</Dialog>
		</ThemeProvider>
	</div>
};

export default DataTx;
